import { render } from "./SubMenuItem.vue?vue&type=template&id=e674651c&ts=true"
import script from "./SubMenuItem.vue?vue&type=script&lang=ts"
export * from "./SubMenuItem.vue?vue&type=script&lang=ts"

import "./SubMenuItem.vue?vue&type=style&index=0&id=e674651c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__